import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StateIcon from "../../Icons/StateIcon";

const StateListComponent = loadable(
  () => import("../../components/State/StateList")
);

const StateList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["state"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.LOCATION}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-end`}
      >
        <StateIcon />
        <span className={tw`w-8 h-8 aspect-square overflow-hidden`}>
          <StateIcon />
        </span>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>State</span>
      </div>
      <StateListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default StateList;
